module.exports = __webpack_public_path__ + "static/img/v21Bg-p.9b30614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21Bg-p.png
// module id = qrB5
// module chunks = 1